<template>
	<transition
	name="NoticeCard"
    enter-active-class="animated fadeInDown"
    leave-active-class="animated fadeOutUp">
		<div class="NoticeCard lf-notice" :class="'lf-notice--'+type">
			<div class="user-content-wrapper">
				<div v-html="data.message"></div>
				<button @click="close" class="st-btn st-btn--right st-btn--sm"><span>X</span></button>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: 'NoticeCard',
	props: {
		id: {
			type: Number
		},
		type: {
			type: String,
			default: 'error'
		},
		data: {
			type: Error,
			default(){
				return new Error("Undefined Error!")
			}
		}
	},
	methods: {
		close(){
			this.$store.commit('core/REMOVE_ERROR', this.id);
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/components/Generals/NoticeCard.vue